export default (x) => String(x)
    .split("")
    .reverse()
    .reduce((acc, n, i) => n + (i && !(i % 3) ? "," : "") + acc)
    .replace("-,", "-");
//# sourceMappingURL=commaFormat.mjs.map